// IntakeForm.js — dispatcher.
//
// Previously routed CA / TX / FL to per-state forms and showed an
// "unsupported state" message for everything else. Now routes ALL 50
// states + DC to the schema-driven IntakeFormUnified.
//
// The legacy per-state forms (IntakeFormCA / TX / FL under
// src/Pages/IntakeForms/) are retained for reference but no longer
// loaded; they can be deleted once the unified flow is in production.

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const SERVER = 'https://api.myemployeemanual.com';
const IntakeFormUnified = React.lazy(() => import('./IntakeFormUnified'));

export default function IntakeForm() {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const [state, setState] = React.useState(null);

  React.useEffect(() => {
    let active = true;
    async function load() {
      try {
        const r = await fetch(`${SERVER}/getUserState?userID=${user.sub}`);
        const data = await r.json();
        if (active) setState(data && data.state ? data.state : '');
      } catch {
        if (active) setState('');
      }
    }
    if (isAuthenticated && user) {
      load();
    } else if (!isLoading) {
      navigate('/');
    }
    return () => { active = false; };
  }, [isAuthenticated, isLoading, user, navigate]);

  if (!isAuthenticated || state === null) return null;

  // Unified form supports every jurisdiction; the state from /getUserState
  // is just a hint for default selection inside the form.
  return (
    <React.Suspense fallback={<div>Loading intake form…</div>}>
      <IntakeFormUnified initialState={state || ''} />
    </React.Suspense>
  );
}
